// extracted by mini-css-extract-plugin
export const editableImg = "smartfire-components-editable-img-style-module__editableImg--2wury";
export const editableImgRelative = "smartfire-components-editable-img-style-module__editableImgRelative--2Ccgo";
export const buttons = "smartfire-components-editable-img-style-module__buttons--3YXyY";
export const componentsPlaceholder = "components-placeholder";
export const image = "smartfire-components-editable-img-style-module__image--dDDKW";